import moment from "moment";
import {useTranslation} from "react-i18next";

const IgnoredUserItem = props => {

    const {t} = useTranslation()
    const {stat,onClick} = props
    return (
        <tr key={stat?.timestamp}>
            <td>
                <div className="xtable__text">
                    {/*<img loading="lazy"className={'sml-img'} src={stat?.game?.image} alt="--"/>*/}
                    <a href="#">{stat?.ignored?.username}</a>
                </div>
            </td>

            <td>
                <div className="xtable__text">
                    <small>
                        {moment.unix(stat?.timestamp || 0).format('YYYY-MM-DD HH:mm:ss')}
                    </small>
                </div>
            </td>

            <td>
                <div
                    onClick={onClick}
                    className="xtable__text xtable__text--red cursor-pointer">
                    {t(`settings.ignored-users.remove`)}
                </div>
            </td>

        </tr>

    )

}

export default IgnoredUserItem
